import * as React from "react";
import { Link } from "react-router-dom";
import LayoutPublico from "../../componentes/Comunes/Layout/LayoutPublico";

class SesionDesconectada extends React.Component {
  render() {
    return (
      <LayoutPublico>
        <h1 className="h1 text-gray-900">Sesión Desconectada</h1>
        <p className="lead text-gray-800">
          La sesión del usuario se ha cerrado.
        </p>
        <Link to="/" className="button-link">
          <button className="btn btn-primary btn-icon-split text-center">
            <span className="icon text-white-50">
              <i className="fas fa-arrow-alt-circle-left"></i>
            </span>
            <span className="text">Volver a Ingresar</span>
          </button>
        </Link>
      </LayoutPublico>
    );
  }
}

export default SesionDesconectada;
